export enum Links {
    termsOfService = 'https://groovycar.com/terms/',
    privacyPolicy = 'https://groovycar.com/privacy/',
    dealerInfo = 'https://groovycar.com/dealers/',
    playStore = 'https://play.google.com/store/apps/details?id=com.groovycar.groovycar',
    appStore = 'https://apps.apple.com/us/app/groovycar/id1517115498'
}

export class Regex {
    public static readonly phoneNumber = RegExp('^[+]*[(]{0,1}[0-9]{3}[)]{0,1}[" "]{0,1}[-s./0-9]{7,12}$');
}

export class Servers {
    public static readonly prodUrls = ['https://api.groovycar.dev', 'https://groovycar.dev'];
}

export enum AppIds {
    playStoreId = 'market://details?id=com.groovycar.groovycar',
    appStoreId = '1517115498'
}

export abstract class AppSettings {
    // this is uid of report, we need some kind of api endpoint do retrieve this? - it exists only for admins
    static readonly conditionReportId = '1UFcqeNF4WdYNHqggKu6YSknMIt';
}

export abstract class VehicleInfo {
    static readonly infoOrder = [
        'nickname',
        'condition',
        'on_lien',
        'lien_amount',
        'make',
        'model',
        'year',
        'trim',
        'engine',
        'engine_size',
        'cylinders',
        'body_type',
        'doors',
        'transmission',
        'drivetrain',
        'fuel_type',
        'manufactured',
        'exterior_color',
        'fabric',
        'interior_color',
        'odometer',
        'odometer_units',
        'vehicle_type',
        'post_code'
    ];

    static readonly pictureOrder = [
        'right-full',
        'right-front',
        'front',
        'left-front',
        'left-full',
        'left-rear',
        'rear',
        'right-rear',
        'interior-front',
        'interior-rear'
    ];
}

export enum ErrorCodes {
    DuplicateVehicleListing = 666,
    GCSubscriptionExpired = 86
}

export abstract class HttpCommon {
    static readonly baseURL = 'https://api.groovycar.dev';

    static isSuccessful(response: any): boolean {
        return (response.hasOwnProperty('status') && response.status === 'success') || response.message === 'pong';
    }
}
